(function() {
  var STATUS_URL = "https://api.bestfy.io/public/shopify/status";
  var CHECKOUT_URL = "https://api.bestfy.io/public/shopify/checkout";
  var STATUS_CACHE_KEY = "bestfy:integration-active";
  var STATUS_CACHE_TTL_MS = 300000;
  var UTM_COOKIE = "bestfy_utms";
  var TBLCI_COOKIE = "bestfy_tblci";
  var FBCLID_COOKIE = "bestfy_fbclid";
  var GCLID_COOKIE = "bestfy_gclid";
  var SKIP_CART = true;
  var shop = (window.Shopify && window.Shopify.shop) || window.location.hostname;

  /* Sem fetch/Promise não dá para concluir o fluxo; não interceptamos (um
     preventDefault sem POST travaria o comprador) e o checkout nativo segue. */
  if (!window.fetch || !window.Promise) return;

  var EXCLUDED_NAMES = {
    update: 1, add: 1, "add-to-cart": 1, plus: 1, minus: 1, remove: 1, clear: 1
  };

  var resolveInFlight = false;
  var wentNative = false;
  var addInFlight = false;
  var replayedNativeAdd = false;

  function lc(value) {
    return (value || "").toLowerCase();
  }

  function attr(el, name) {
    return (el.getAttribute && el.getAttribute(name)) || "";
  }

  function cacheGet(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function cacheSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  /* O cache guarda "true:<epoch-ms>" / "false:<epoch-ms>" e expira em 5 min:
     sem TTL, um "false" gravado antes de o lojista ativar a integração
     manteria a sessão inteira indo para o checkout nativo. Valor vencido ou em
     formato inesperado vira desconhecido e é revalidado no warmStatus. */
  var activeState = (function() {
    var cached = cacheGet(STATUS_CACHE_KEY);
    if (!cached) return null;
    var separator = cached.indexOf(":");
    if (separator === -1) return null;
    var writtenAt = parseInt(cached.slice(separator + 1), 10);
    if (!writtenAt || Date.now() - writtenAt > STATUS_CACHE_TTL_MS) return null;
    var flag = cached.slice(0, separator);
    if (flag === "true") return true;
    if (flag === "false") return false;
    return null;
  })();

  function saveUtms() {
    var params = new URLSearchParams(window.location.search);
    var utms = {};
    var found = false;

    /* Reescritores de URL (ex.: Utmify) acrescentam a família utm_* inteira preenchendo os ausentes
       como vazio; valor vazio não é atribuição e o backend o descartaria de qualquer forma. */
    params.forEach(function(value, key) {
      if (key.indexOf("utm_") === 0 && value) {
        utms[key] = value;
        found = true;
      }
    });

    if (found) {
      document.cookie =
        UTM_COOKIE + "=" + encodeURIComponent(JSON.stringify(utms)) +
        "; path=/; max-age=604800";
    }
  }

  function readUtms() {
    var match = document.cookie.match(
      new RegExp("(?:^|; )" + UTM_COOKIE + "=([^;]*)")
    );
    if (!match) return null;

    try {
      return JSON.parse(decodeURIComponent(match[1]));
    } catch (error) {
      return null;
    }
  }

  /* Click ids (tblci/fbclid) são case-sensitive e opacos: capturados íntegros, sem normalização
     nem truncamento — valor acima do teto do backend é ignorado (não truncado), senão viraria um
     cookie de 7 dias reenviado em todo checkout. Como nas UTMs, só sobrescrevem quando presentes
     na URL (o último clique vence). */
  function saveClickId(param, cookie, maxLength) {
    var params = new URLSearchParams(window.location.search);
    var value = params.get(param);
    if (value && value.length <= maxLength) {
      document.cookie =
        cookie + "=" + encodeURIComponent(value) +
        "; path=/; max-age=604800";
    }
  }

  function readClickId(cookie) {
    var match = document.cookie.match(
      new RegExp("(?:^|; )" + cookie + "=([^;]*)")
    );
    if (!match) return null;

    try {
      return decodeURIComponent(match[1]);
    } catch (error) {
      return null;
    }
  }

  /* Identidade do GA4 no domínio da loja: client_id do cookie _ga ("GA1.1.<random>.<ts>" -> últimos
     2 segmentos) e session_id do cookie _ga_<container> (formatos GS1 "GS1.1.<sid>..." e GS2
     "GS2.1.s<sid>$..."). Lidos na hora do checkout (os cookies do gtag já são duráveis na loja);
     valor malformado ou container ambíguo vira null e o backend segue sem o par. */
  function readGaClientId() {
    var value = readClickId("_ga");
    if (!value) return null;

    var parts = value.split(".");
    if (parts.length < 4) return null;

    var clientId = parts.slice(-2).join(".");
    return new RegExp("^[0-9]+[.][0-9]+$").test(clientId) ? clientId : null;
  }

  function readGaSessionId() {
    var matches = document.cookie.match(
      new RegExp("(?:^|; )_ga_[^=]+=[^;]*", "g")
    );
    if (!matches || matches.length !== 1) return null;

    var rawValue = matches[0].split("=").slice(1).join("=");
    var value;
    try {
      value = decodeURIComponent(rawValue);
    } catch (error) {
      return null;
    }

    var parts = value.split(".");
    if (parts.length < 3) return null;

    var digitsOnly = new RegExp("^[0-9]+$");
    if (parts[0] === "GS2") {
      var fields = parts[2].split("$");
      for (var i = 0; i < fields.length; i++) {
        if (fields[i].charAt(0) === "s" && digitsOnly.test(fields[i].slice(1))) {
          return fields[i].slice(1);
        }
      }
      return null;
    }

    return digitsOnly.test(parts[2]) ? parts[2] : null;
  }

  function hideDynamicCheckout() {
    if (document.getElementById("bestfy-hide-dynamic-checkout")) return;
    var style = document.createElement("style");
    style.id = "bestfy-hide-dynamic-checkout";
    /* Oculta o container (no documento pai) dos botões de checkout dinâmico/
       acelerado da Shopify nas duas marcações conhecidas: a do formulário de
       produto (data-shopify="payment-button" / .shopify-payment-button) e a do
       carrinho/gaveta, gerada por content_for_additional_checkout_buttons
       (.additional-checkout-buttons / shopify-accelerated-checkout[-cart]).
       Ocultar o container remove o iframe da carteira (PayPal/Shop Pay), que
       não conseguimos interceptar a partir do documento pai. */
    style.textContent = '[data-shopify="payment-button"],[data-shopify="dynamic-checkout-cart"],.shopify-payment-button,.additional-checkout-buttons,shopify-accelerated-checkout,shopify-accelerated-checkout-cart{display:none !important;}';
    (document.head || document.documentElement).appendChild(style);
  }

  function warmStatus() {
    return fetch(STATUS_URL + "?shop=" + encodeURIComponent(shop))
      .then(function(response) { return response.json(); })
      .then(function(data) {
        var active = !!(data && data.active);
        activeState = active;
        /* Só cacheia resultado definitivo; um erro não é gravado para não
           envenenar a sessão (a próxima navegação tenta de novo). */
        cacheSet(STATUS_CACHE_KEY, String(active) + ":" + Date.now());
        if (active) hideDynamicCheckout();
        return active;
      })
      .catch(function() {
        activeState = false;
        return false;
      });
  }

  var statusPromise =
    activeState === null ? warmStatus() : Promise.resolve(activeState);

  function pathOf(url) {
    var value = lc(url);
    var scheme = value.indexOf("://");
    if (scheme !== -1) {
      var rest = value.slice(scheme + 3);
      var slash = rest.indexOf("/");
      value = slash === -1 ? "/" : rest.slice(slash);
    }
    var query = value.indexOf("?");
    if (query !== -1) value = value.slice(0, query);
    var hash = value.indexOf("#");
    if (hash !== -1) value = value.slice(0, hash);
    return value;
  }

  function isLocaleSegment(segment) {
    if (segment.length !== 2 && segment.length !== 5) return false;
    for (var i = 0; i < segment.length; i++) {
      var ch = segment.charAt(i);
      if (segment.length === 5 && i === 2) {
        if (ch !== "-") return false;
      } else if (ch < "a" || ch > "z") {
        return false;
      }
    }
    return true;
  }

  /* Casa /checkout no início do path ou precedido só por segmentos de locale
     (/fr, /en-ca); páginas como /pages/checkout não são gatilho de compra. */
  function leadsToCheckout(path) {
    var i = path.indexOf("/checkout");
    if (i === -1) return false;
    var after = path.charAt(i + 9);
    if (after !== "" && after !== "/" && after !== "?" && after !== "#") {
      return false;
    }
    var prefixSegments = path.slice(0, i).split("/");
    for (var s = 0; s < prefixSegments.length; s++) {
      if (prefixSegments[s] && !isLocaleSegment(prefixSegments[s])) {
        return false;
      }
    }
    return true;
  }

  function leadsToCartAdd(path) {
    return path.indexOf("/cart/add") !== -1;
  }

  function isCartMutation(path) {
    return (
      path.indexOf("/cart/update") !== -1 ||
      path.indexOf("/cart/change") !== -1 ||
      leadsToCartAdd(path)
    );
  }

  function getForm(el) {
    if (el.form) return el.form;
    var node = el.parentNode;
    while (node && node.nodeType === 1) {
      if (lc(node.tagName) === "form") return node;
      node = node.parentNode;
    }
    return null;
  }

  function isSubmitControl(el) {
    var tag = lc(el.tagName);
    var type = lc(attr(el, "type"));
    if (tag === "button") return type === "submit" || type === "";
    if (tag === "input") return type === "submit" || type === "image";
    return false;
  }

  function isCartCheckoutLink(el) {
    var href = pathOf(attr(el, "href"));
    if (href !== "/cart" && href.slice(-5) !== "/cart") return false;
    if (isCartMutation(href)) return false;
    var cls = lc(attr(el, "class"));
    return cls.indexOf("checkout") !== -1;
  }

  function isCheckoutTrigger(el) {
    if (!el || el.nodeType !== 1) return false;
    var tag = lc(el.tagName);
    var name = lc(attr(el, "name"));

    if (name === "checkout") return true;
    if (tag === "a") {
      if (leadsToCheckout(pathOf(attr(el, "href")))) return true;
      if (isCartCheckoutLink(el)) return true;
      return false;
    }
    if (lc(attr(el, "data-shopify")) === "payment-button") return true;

    if (isSubmitControl(el)) {
      if (EXCLUDED_NAMES[name] === 1) return false;

      var formaction = pathOf(attr(el, "formaction"));
      if (formaction) {
        if (isCartMutation(formaction)) return false;
        if (leadsToCheckout(formaction)) return true;
      }

      var form = getForm(el);
      var action = form ? pathOf(attr(form, "action")) : "";
      if (leadsToCheckout(action)) return true;
      /* Enviar o formulário do carrinho (action /cart) leva ao checkout. */
      if (action === "/cart" || action.slice(-5) === "/cart") return true;
    }

    return false;
  }

  function findTrigger(node) {
    while (node && node !== document) {
      if (node.nodeType === 1 && isCheckoutTrigger(node)) return node;
      node = node.parentNode;
    }
    return null;
  }

  /* Encaminha ao checkout nativo por navegação direta, nunca reenviando o
     clique/submit original: replays sintéticos dependem do tema (validação do
     form, JS próprio, semântica de submitter) e falham em silêncio. GET
     /checkout é o ponto de entrada universal da Shopify e monta o checkout a
     partir do carrinho salvo no cookie (carrinho vazio cai na página /cart). */
  function goNative(el) {
    if (wentNative) return;
    wentNative = true;

    if (el && lc(el.tagName) === "a" && el.href) {
      window.location.href = el.href;
      return;
    }

    window.location.href = "/checkout";
  }

  function resolveCheckout(el) {
    if (resolveInFlight) return;
    resolveInFlight = true;

    fetch("/cart.json")
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var items = (cart && cart.items) || [];

        if (items.length === 0) {
          resolveInFlight = false;
          goNative(el);
          return null;
        }

        /* O ALB/WAF de dev/prod bloqueia corpos > 8 KB (403 sem headers CORS);
           o cart.json cru chegou a ~4 KB com 2 itens, então enviamos só as
           triplas dos line items para nunca encostar no limite. */
        return fetch(CHECKOUT_URL, {
          method: "POST",
          headers: { "Content-Type": "text/plain" },
          body: JSON.stringify({
            shop: shop,
            cartToken: cart.token,
            items: items.map(function(item) {
              return {
                shopifyProductId: item.product_id,
                shopifyVariantId: item.variant_id,
                quantity: item.quantity
              };
            }),
            utms: readUtms(),
            tblci: readClickId(TBLCI_COOKIE),
            fbclid: readClickId(FBCLID_COOKIE),
            gclid: readClickId(GCLID_COOKIE),
            gaClientId: readGaClientId(),
            gaSessionId: readGaSessionId()
          })
        });
      })
      .then(function(response) { return response ? response.json() : null; })
      .then(function(data) {
        /* null: carrinho vazio, já resolvido acima com goNative. */
        if (data === null) return;
        if (data.checkoutUrl) {
          /* Mantém resolveInFlight travado: já estamos navegando, evita 2º POST. */
          window.location.href = data.checkoutUrl;
        } else {
          resolveInFlight = false;
          goNative(el);
        }
      })
      .catch(function(error) {
        /* Em falha na resolução do checkout, caímos para o /checkout nativo da
           Shopify em vez de deixar o comprador preso na página sem resposta. */
        resolveInFlight = false;
        console.error("[bestfy] checkout resolve failed", error);
        goNative(el);
      });
  }

  /* Regra única de roteamento pelo status: age na hora quando ativo, retém a ação enquanto o
     status resolve e cai para o caminho nativo quando inativo. */
  function whenActive(el, run, fallback) {
    if (activeState === true) {
      run(el);
      return;
    }
    statusPromise.then(function(active) {
      if (active) run(el);
      else fallback(el);
    });
  }

  /* Reenvia o formulário pelo caminho nativo: form.submit() ignora todos os
     listeners de submit (nossos e do tema) e faz o POST /cart/add puro, que a
     Shopify trata sozinha (302 para /cart ou página de erro). Usado quando a
     adição via AJAX falha ou quando o status resolve inativo. */
  function replayNativeAdd(form) {
    if (replayedNativeAdd) return;
    replayedNativeAdd = true;
    form.submit();
  }

  function addThenResolve(form) {
    if (addInFlight) return;
    addInFlight = true;

    fetch("/cart/add.js", { method: "POST", body: new FormData(form) })
      .then(function(response) {
        if (response.ok) {
          /* Mantém addInFlight travado: seguimos para o resolve e a navegação. */
          resolveCheckout(form);
          return;
        }
        addInFlight = false;
        replayNativeAdd(form);
      })
      .catch(function(error) {
        addInFlight = false;
        console.error("[bestfy] cart add failed", error);
        replayNativeAdd(form);
      });
  }

  document.addEventListener("click", function(e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var trigger = findTrigger(e.target);
    if (!trigger) return;
    if (activeState === false) return;

    e.preventDefault();
    e.stopPropagation();
    whenActive(trigger, resolveCheckout, goNative);
  }, true);

  /* Enter num campo dispara submit. Só interceptamos formulários que postam
     direto para /checkout; nunca o form do carrinho (action /cart), pois lá o
     Enter normalmente aciona "atualizar", não "finalizar". */
  document.addEventListener("submit", function(e) {
    var form = e.target;
    if (!form || lc(form.tagName) !== "form") return;
    if (!leadsToCheckout(pathOf(attr(form, "action")))) return;
    if (activeState === false) return;

    e.preventDefault();
    e.stopPropagation();
    whenActive(form, resolveCheckout, goNative);
  }, true);

  /* Pular carrinho: ouvimos o submit do formulário de produto em fase de
     bolha, DEPOIS dos handlers do tema. Se o tema já tratou o submit
     (preventDefault, caso dos carrinhos AJAX de gaveta), não tocamos em nada e
     adicionar ao carrinho segue adicionando. Se ninguém tratou, o navegador
     faria o POST /cart/add nativo e aterrissaria na página /cart; é esse
     desvio que pulamos: a adição acontece via /cart/add.js e seguimos direto
     para o resolve do checkout. */
  if (SKIP_CART) {
    document.addEventListener("submit", function(e) {
      if (e.defaultPrevented) return;
      var form = e.target;
      if (!form || lc(form.tagName) !== "form") return;
      if (!leadsToCartAdd(pathOf(attr(form, "action")))) return;
      if (activeState === false) return;

      e.preventDefault();
      e.stopPropagation();
      whenActive(form, addThenResolve, replayNativeAdd);
    }, false);
  }

  if (activeState === true) hideDynamicCheckout();

  try {
    saveUtms();
    saveClickId("tblci", TBLCI_COOKIE, 512);
    saveClickId("fbclid", FBCLID_COOKIE, 500);
    saveClickId("gclid", GCLID_COOKIE, 512);
  } catch (error) {
    return;
  }
})();